import type { OmuiFileIconWithTooltipActionsComponent } from '../../FileIconWithTooltipActions'

export const OmuiFileIconWithTooltipActions: OmuiFileIconWithTooltipActionsComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.bg.surface.elevated,
      border: `${theme.strokeWidth.strong} solid ${theme.palette.border.subtle}`,
      borderRadius: theme.shape['radius-md'],
      boxShadow: theme.customShadows.md,
      minWidth: 280,
      maxWidth: 360,
      color: theme.palette.text.default,
      textAlign: 'left',
      overflow: 'hidden',
    }),
    icon: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'default',
    },
    header: ({ theme }) => ({
      gap: theme.spacing(3),
      padding: theme.spacing(4),
    }),
    fileName: {
      wordBreak: 'break-word',
    },
    metadata: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    divider: {},
    actions: ({ theme }) => ({
      justifyContent: 'flex-end',
      gap: theme.spacing(4.5),
      padding: theme.spacing(4),
      '& .MuiButton-root': {
        textTransform: 'none',
      },
    }),
  },
}
